//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import GoHome from '@/components/subComponents/GoHome'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "Order",
    components: {
        GoHome,
        MyBtnReturn,
    },
    data() {
        return {
            // todo:逻辑应该是：上层中某个选项变化了，下面所有select与受影响的input都要变为null
            shipper: null,
            shipperOps: [],
            employeeId: '',
            load_date: '',
            consignee_id: null, // 囧，selector组件要设置默认值为null时，placeholder才有效果！
            consigneeOps: [
                // {
                //   key: 'lsh',
                //   value: '李四'
                // },
                // {
                //   key: 'zhs',
                //   value: '张三'
                // }
            ],
            goods_name: '',
            dockOfLoading: null,
            dockOfLoadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            finalDestination: null,
            finalDestinationOps: [],
            jhr: null,
            jhrOps: [],
            company_lxr: null,
            company_lxrOps: [],
            shipper_tel: '',
            shipper_mp: '',
            remark3: '', // 装货说明
            consignee_place: null,
            consignee_placeOps: [],
            consignee_linkman: null,
            consignee_linkmanOps: [],
            consignee_tel: '',
            consignee_mp: '',
            remark9: '', // 卸货说明
            carriage: null,
            carriageOps: [
                {
                    key: 'DR-DR',
                    value: '门/门'
                },
                {
                    key: 'DR-CY',
                    value: '门/堆场'
                },
                {
                    key: 'CY-DR',
                    value: '堆场/门'
                },
                {
                    key: 'CY-CY',
                    value: '堆场/堆场'
                },
            ],
            contQty: '', // todo:柜量还要进行处理？
            contType: null,
            contTypeOps: [
                // {
                //   key: '20',
                //   value: '20GP'
                // },
                // {
                //   key: '40',
                //   value: '20GP'
                // },
                // {
                //   key: '4',
                //   value: '4GP'
                // },
            ], // todo:后台传递来
            insurance_status: null,
            insurance_statusOps: [
                {
                    key: '1',
                    value: '是'
                },
                {
                    key: '0',
                    value: '否'
                },
            ],
            fees_remark2: '',
            isDisabledList: {
                shipperSelector: false,
                consigSelector: false,
                dockOfLoadingSelector: false,
                finalDestinationSelector: false,
                jhrSelector: false,
                companyLxrSelector: false,
                consigneePlaceSelector: false,
                consigneeLinkmanSelector: false,
            }, // 这个对象存放控制各个selector组件的readonly属性的值
            canSubmit: true,
        }
    },
    created() {
        document.title = '业务下单';
        this.getInitialSelectData()
    },
    methods: {
        getInitialSelectData() {
            // 可获取到shippers(托运人列表)、employeeId(对应业务员？)、conts(柜型柜量)
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: apiUrl.getShippersAndConts,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                let dataObj = resultData.data;
                this.shipperOps = dataObj.shippers;
                this.employeeId = dataObj.employeeId;
                this.contTypeOps = dataObj.conts
            }, (error) => {
                this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(() => {
                        this.getInitialSelectData()
                    }, 2000);
                    console.error(error);
                }
            })
        },
        // 所有selector的on-change方法都换成原生的change,记得要.native；（这是为了避免初始化selector时自动运行一次on-change）
        async changeShipper(value, ref) {
            // 托运人一改变，要去请求getConsignee获取货主
            // 为了正常使用isDisabled方法，只能弄成同步了！
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 与getStartArea获取起运地
            await this.getConsignee();
            await this.getStartArea();
            this.isDisabled(ref)
        },
        getConsignee(value, ref) {
            // 获取货主：根据托运人查询
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
            };
            this.requestApi({
                url: apiUrl.getConsignee,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.consigneeOps = dataObj.consignee
            }, (error) => {
                if (error) {
                    // todo:除了getInitialSelectData可以自动重新请求外，其他change事件触发的接口不可自动重新获取，不然万一用户修改选项，请求数据会混乱了！
                    // 处理上述bug：因此如果请求失败了，那就重置select的默认值为null
                    this.shipper = null;
                    console.error(error);
                }
            })
        },
        getStartArea(value, ref) {
            // 获取起运地：根据托运人查询
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
            };
            this.requestApi({
                url: apiUrl.getStartArea,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.dockOfLoadingOps = dataObj.startArea
            }, (error) => {
                if (error) {
                    this.shipper = null;
                    console.error(error);
                }
            })
        },
        getArea(value, ref) {
            // 获取目的地：通过托运人与货主去查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取目的地：通过托运人与货主去查询
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper,
                consignee_id: this.consignee_id || '',
            };
            this.requestApi({
                url: apiUrl.getArea,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.finalDestinationOps = dataObj.area
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.consignee_id = null;
                    console.error(error);
                }
            })
        },
        getLoadJhr(value, ref) {
            // 获取装货地址：根据起运地查询
            // on-change事件的参数value就是selector组件被选中的选项
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '', // 也可以直接使用参数value
            };
            this.requestApi({
                url: apiUrl.getPlace,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.jhrOps = dataObj.places
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.dockOfLoading = null;
                    console.error(error);
                }
            })
        },
        getConsigPlace(value, ref) {
            // 获取卸货地址：根据目的地去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
            };
            this.requestApi({
                url: apiUrl.getPlace,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.consignee_placeOps = dataObj.places
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.finalDestination = null;
                    console.error(error);
                }
            })
        },
        getLoadLink(value, ref) {
            // 获取装货联系人：根据起运地+装货地址去查询
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '',
                place: this.jhr || '',
            };
            this.requestApi({
                url: apiUrl.getLinkman,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.company_lxrOps = dataObj.linkmans
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.jhr = null;
                    console.error(error);
                }
            })
        },
        getLoadTelMp(value, ref) {
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取装货人手机电话：根据起运地+装货地址+装货联系人获取
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.dockOfLoading || '',
                place: this.jhr || '',
                linkman: this.company_lxr || '',
            };
            this.requestApi({
                url: apiUrl.getOtherloadInfo,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                // 手机与电话好像是放在loadInfo数组里面
                this.shipper_tel = dataObj.loadInfo[1];
                this.shipper_mp = dataObj.loadInfo[0]
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.company_lxr = null;
                    console.error(error);
                }
            })
        },
        getXHLink(value, ref) {
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货联系人：根据目的地+卸货地址获取
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
                place: this.consignee_place || '',
            };
            this.requestApi({
                url: apiUrl.getLinkman,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.consignee_linkmanOps = dataObj.linkmans
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.consignee_place = null;
                    console.error(error);
                }
            })
        },
        getXhTelMp(value, ref) {
            if (!value) return; // 由于on-change会立即调用一次，因此如果value为null，要中止函数
            this.isDisabled(ref);
            // 获取卸货人手机电话：根据目的地+卸货地址+卸货联系人获取
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                consignee_id: this.consignee_id || '',
                area: this.finalDestination || '',
                place: this.consignee_place || '',
                linkman: this.consignee_linkman || '',
            };
            this.requestApi({
                url: apiUrl.getOtherloadInfo,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                this.consignee_tel = dataObj.loadInfo[0];
                this.consignee_mp = dataObj.loadInfo[1]
            }, (error) => {
                this.isDisabled(ref);
                if (error) {
                    this.consignee_linkman = null;
                    console.error(error);
                }
            })
        },
        submit(e) {
            // 对表单各项进行检测
            if (!this.shipper) {
                this.showToastWarn('请输入托运人');
                return
            }
            if (!this.load_date) {
                this.showToastWarn('请选择装货时间');
                return
            }
            if (!this.consignee_id) {
                this.showToastWarn('请输入货主');
                return
            }
            if (!this.goods_name) {
                this.showToastWarn('请输入货名');
                return
            }
            if (!this.dockOfLoading) {
                this.showToastWarn('请输入起运地');
                return
            }
            if (!this.finalDestination) {
                this.showToastWarn('请输入目的地');
                return
            }
            if (!this.jhr) {
                this.showToastWarn('请输入装货地址');
                return
            }
            if (!this.company_lxr) {
                this.showToastWarn('请输入装货联系人');
                return
            }
            if (!(this.shipper_mp || this.shipper_tel)) {
                this.showToastWarn('装货联系人手机,电话至少输入一个');
                return
            }
            if (!this.consignee_place) {
                this.showToastWarn('请输入卸货地址');
                return
            }
            if (!this.consignee_linkman) {
                this.showToastWarn('请输入卸货联系人');
                return
            }
            if (!(this.consignee_tel || this.consignee_mp)) {
                this.showToastWarn('卸货联系人手机,电话至少输入一个');
                return
            }
            if (!this.contQty) {
                this.showToastWarn('请输入柜量');
                return
            } else if (isNaN(Number(this.contQty))) {
                // 柜量必须是数字，而且是整数
                this.showToastWarn('柜量必须为数字');
                return
            }
            if (!this.fees_remark2) {
                this.showToastWarn('请输入费用说明');
                return
            }
            // 防止连续调用接口
            if (!this.canSubmit) {
                console.error('不可点击');
                return
            }
            this.canSubmit = false;
            this.$vux.loading.show({
                text: 'Loading'
            });
            // 提交下单信息
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                shipper: this.shipper || '',
                employeeId: this.employeeId || '',
                load_date: this.load_date,
                consignee_id: this.consignee_id,
                goods_name: this.goods_name,
                dockOfLoading: this.dockOfLoading,
                finalDestination: this.finalDestination,
                jhr: this.jhr,
                company_lxr: this.company_lxr,
                shipper_tel: this.shipper_tel || '',
                shipper_mp: this.shipper_mp || '',
                remark3: this.remark3,
                consignee_place: this.consignee_place,
                consignee_linkman: this.consignee_linkman,
                consignee_tel: this.consignee_tel || '',
                consignee_mp: this.consignee_mp || '',
                remark9: this.remark9,
                carriage_item: this.carriage,
                contQty: parseInt(this.contQty), // 柜量必须为整数
                contType: this.contType,
                insurance_status: this.insurance_status || 0,
                fees_remark2: this.fees_remark2,
                group: this.group,
            };
            this.requestApi({
                url: apiUrl.addOrder,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                // 最后判断下单是否成功，给toast，状态码为200就是成功
                let dataObj = resultData.data;
                this.showToast(dataObj.info, 1500, 'success', {
                    onHide: () => {
                        this.$router.push('/home')
                    }
                })
            }, (error) => {
                this.canSubmit = true;
                this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            })
        },
        showToastWarn(text, time = 1500) {
            // 专门给submit函数里的验证使用
            this.showToast(text, time, 'warn')
        },
        isDisabled(ref) {
            // 在触发select的change事件后，要先禁用select，等到请求完毕后，再重启select功能
            // 两种实现方式：1、第一种是通过ref获取到对应dom元素，然后禁用：
            // this.$refs[ref].$el.querySelector('select').disabled = !this.$refs[ref].$el.querySelector('select').disabled

            // 2、第二种是控制对应数据去设置selector组件的readonly属性
            this.isDisabledList[ref] = !this.isDisabledList[ref]
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/yewu/order/Order.vue